import { createFeatureSelector, createSelector } from '@ngrx/store';
import { companyStateDataType } from '../../core/models/Interfaces/company';

export const companyStoreData =
  createFeatureSelector<companyStateDataType>('company');

export const companyStateData = createSelector(
  companyStoreData,
  (state: any) => state,
);

export const companyOwnerCitiesData = createSelector(
  companyStoreData,
  (state: any) => state.companyOwnerCities,
);
